// 读取所有svg文件
import Vue from 'vue'
import localSvg from '@/icons/localSvg.vue'// 引入svg组件

// 注册全局组件
Vue.component('local-svg', localSvg)
// require.context，通过正则匹配到可能的文件，全部引入
const req = require.context('./svg', false, /\.svg$/)
const requireAll = requireContext => requireContext.keys().map(requireContext)
requireAll(req)